import React, { useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { data } from "../../../constants";
import { TableButtonWrapper, TextStyled } from "./elements";
import { Positions } from "../../templates/Positions";
import { Button } from "../../atoms/Button";
import {
  clearPositionValues,
  fetchPositions,
} from "../../../redux/position/action";
import { useHistory } from "react-router";
import { ADD_POSITION_REQUEST, UPDATE_POSITION_REQUEST } from "../../../redux/position/actionType";
import { SEARCH_APPLICANT_REQUEST } from "../../../redux/applicant/actionTypes";
import { Alert } from "../../atoms/Alert";
import { clearSpecificRequest } from "../../../redux/request/action";

const PositionsPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPositions());
    dispatch(clearSpecificRequest(SEARCH_APPLICANT_REQUEST));
    return () => {
      dispatch(clearPositionValues());
      dispatch(clearSpecificRequest(ADD_POSITION_REQUEST));
      dispatch(clearSpecificRequest(UPDATE_POSITION_REQUEST));
    };
  }, [dispatch]);

  const isLoading = useSelector(
    (state: RootStateOrAny) => state.position.isLoading
  );

  const positions = useSelector(
    (state: RootStateOrAny) => state.position.positions
  );

  const addRequest = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[ADD_POSITION_REQUEST]
  );

  const updateRequest = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[UPDATE_POSITION_REQUEST]
  );

  const onClickCreatePosition = () => {
    dispatch(clearPositionValues());
    return history.push("/admin/positions/create");
  };

  const onClickUpdatePosition = (key: any) => {
    dispatch(clearPositionValues());
    return history.push(`/admin/positions/${key}`);
  };

  const columns = [
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      width: "240px",
      filters: data.positionApplied.map((position: string) => {
        return { text: position, value: position };
      }),
      onFilter: (value: any, record: any) =>
        record.position.indexOf(value) === 0,
      render: (text: any, record: any) => (
        <TextStyled isClosed={record.status === "Closed"}>{text}</TextStyled>
      ),
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "200px",
      render: (text: any, record: any) => (
        <TextStyled isClosed={record.status === "Closed"}>{text}</TextStyled>
      ),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      width: "180px",
      render: (text: any, record: any) => (
        <TextStyled isClosed={record.status === "Closed"}>{text}</TextStyled>
      ),
    },
    {
      title: "Actions",
      dataIndex: "key",
      key: "actions",
      width: "230px",
      render: (text: any, record: any) => (
        <TableButtonWrapper>
          <Button type="default" onClick={() => onClickUpdatePosition(text)}>
            Update
          </Button>
        </TableButtonWrapper>
      ),
    },
  ];

  return (
    <>
      <Positions
        isLoading={isLoading}
        tableData={positions}
        columns={columns}
        onCreatePositionClick={onClickCreatePosition}
      />
      {addRequest?.didSucceed && addRequest?.response && (
        <Alert type="success" message="Position successfully added" showIcon />
      )}
      {updateRequest?.didSucceed && updateRequest?.response && (
        <Alert type="success" message="Position successfully updated" showIcon />
      )}
    </>
  );
};

export default PositionsPage;
